import { Box, Button } from "@mui/material";
import React from "react";
import styles from "./styles.module.css";
import SkillStatus from "./components/status";
import AboutSkill from "./components/skill-about";
import SkillsBar from "./components/skills-bar";
import SkillCoverImage from "./components/skills-cover-image";
import { Link } from "react-router-dom";
import DeleteConfirmation from "./components/delete-skill";
import LoadingButton from "../../../components/loading/button";
import { useTheme } from "../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import { updateDelete } from "../../../store/slices/infoSlice";
import useSkillsView from "../../../hooks/skills/useSkillsView";
import HWC from "./components/HWC";

const MySkills = () => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const { activeUserSkill } = useSelector((state) => state.user);
  // useDiscover(true);
  const { buttonLoading } = useSelector((state) => state.isLoading);
  useSkillsView();

  const style = {
    display: "flex",
    padding: "16px 24px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "16px",
    alignSelf: "stretch",
  };

  if (buttonLoading) {
    return (
      <Box className={styles.loading}>
        <LoadingButton />
      </Box>
    );
  }

  if (!activeUserSkill) {
    return (
      <Box>
        <Box sx={style}>
          <SkillsBar />
        </Box>
        <HWC />
      </Box>
    );
  }

  return (
    <Box sx={style}>
      <SkillsBar />
      <HWC />
      <DeleteConfirmation />
      <SkillCoverImage />
      <SkillStatus />
      <AboutSkill />
      <Link
        underline="none"
        to={"/edit-skill/" + activeUserSkill?.id}
        style={{ width: "100%" }}
      >
        <Button variant="contained" fullWidth>
          Edit
        </Button>
      </Link>
      <Button
        onClick={() => dispatch(updateDelete({ isDeleteOpen: true }))}
        variant="text"
        sx={{
          p: "0px",
          color: theme.palette.darkgrey.darkgrey400,
          textTransform: "capitalize",
          fontSize: "16px",
          fontWeight: "500",
          width: {
            xs: "100%",
          },
        }}
      >
        Delete
      </Button>
    </Box>
  );
};

export default MySkills;
